export default __webpack_public_path__ + "dist/the-card-game/main.min.css";